import { useEffect, useState } from "react";
import Card from "./Card";

type Props = {
  locationName: string;
  carclass: string;
  featureData: {
    title: string;
    subtitle: string;
    desc: string;
  }[];
};

const ClassCarFeatures = (props: Props) => {
  const [isUserAgentBot, setIsUserAgentBot] = useState(true);
  useEffect(() => {
    if (!/bot/i.test(navigator.userAgent)) setIsUserAgentBot(false);
  }, []);
  return (
    <section id="features-cards" className="px-[13px]">
      <div className="max-w-7xl mx-auto mt-[22px] mb-[18px] lg:my-[60px]">
        <div className="space-y-[6px] lg:space-y-[10px] mb-[18px]">
          <h2 className="font-extrabold text-lg lg:text-[30px] text-my-dark-blue leading-[2.2rem]">
            {`Things to know while renting a ${props.carclass} Car in ${props.locationName}`}
          </h2>
          <p className="space-y-6 text-sm font-normal text-my-light-blue lg:font-light lg:text-base">
            {`If you are looking for a great car rental experience from ${props.locationName}, look no further than ${props.carclass} cars.`}
          </p>
        </div>
        {isUserAgentBot ? (
          <table className="w-full">
            {props.featureData.map((data, index) => {
              return (
                <tr key={index}>
                  <th>{data.subtitle}</th>
                  <td>{data.title}</td>
                </tr>
              );
            })}
          </table>
        ) : (
          <div className="md:grid grid-cols-2 lg:grid-cols-4 gap-6 rounded-[16px] md:rounded-none overflow-clip mt-[18px] lg:mt-10">
            {props.featureData.map((data, index) => {
              return (
                <Card
                  key={index}
                  subtitle={data.subtitle}
                  title={data.title}
                  desc={data.desc}
                />
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default ClassCarFeatures;
